<!-- src/apps/workspace/components/dashboard/DomainsTableDomainCell.vue -->

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import DomainVerificationInfo from '@/apps/workspace/components/domains/DomainVerificationInfo.vue';
  import { useDomainStatus } from '@/shared/composables/useDomainStatus';
  import type { CustomDomain } from '@/schemas/models/domain';
  import { formatDistanceToNow } from 'date-fns';

const { t } = useI18n();

  interface Props {
    domain: CustomDomain;
    orgid: string;
  }

  const props = defineProps<Props>();

  const status = useDomainStatus(props.domain);
</script>

<template>
  <div class="flex flex-col space-y-2">
    <div class="flex items-center space-x-2">
      <router-link
        v-if="status.isActive.value"
        :to="{ name: 'DomainBrand', params: { orgid: props.orgid, extid: domain.extid } }"
        class="font-brand text-lg text-brandcomp-600 hover:text-brandcomp-700 dark:text-brandcomp-400 dark:hover:text-brandcomp-300">
        {{ domain.display_domain }}
      </router-link>
      <router-link
        v-else
        :to="{ name: 'DomainVerify', params: { orgid: props.orgid, extid: domain.extid } }"
        class="font-brand text-lg text-brandcomp-600 hover:text-brandcomp-700 dark:text-brandcomp-400 dark:hover:text-brandcomp-300">
        {{ domain.display_domain }}
      </router-link>

      <!-- heroicons/outline/external-link -->
      <a
        :href="`https://${domain.display_domain}`"
        target="_blank"
        rel="noopener noreferrer"
        class="inline-flex items-center text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300"
        :title="t('web.domains.open_domain_in_new_tab')">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="size-4"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round">
          <path d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
        </svg>
      </a>
    </div>

    <div class="flex items-start space-x-2">
      <DomainVerificationInfo
        mode="icon"
        :domain="domain"
        :orgid="props.orgid"
        class="-mt-0.5 shrink-0" />

      <span class="text-xs text-gray-500 dark:text-gray-400">
        {{
          t('web.domains.added_formatdistancetonow_domain_created_addsuffix_true', [
            formatDistanceToNow(domain.created, { addSuffix: true }),
          ])
        }}
      </span>
    </div>
  </div>
</template>
